import { CustomInputRinforzoNodoValue } from "../types";
export const FC_OPTION_VALUES = [1, 1.2, 1.35];

export const FIELDS = {
  compressione: {
    required: true,
    numeric: true,
    mu: "MPa",
    symbol: (
      <>
        f<sub>cm</sub>
      </>
    ),
    localization: {
      id: "compressione",
      defaultMessage: "Resistenza media a compressione",
    },
  },
  fattore_confidenza: {
    required: true,
    numeric: true,
    mu: "",
    symbol: <>FC</>,
    localization: {
      id: "fattore_confidenza",
      defaultMessage: "Fattore di confidenza",
    },
  },
  coefficente_sicurezza: {
    required: true,
    numeric: true,
    mu: "",
    symbol: <>&gamma;<sub>c</sub></>,
    localization: {
      id: "coefficente_sicurezza",
      defaultMessage: "Coefficiente di sicurezza",
    },
  },
  copriferro: {
    required: true,
    numeric: true,
    mu: "mm",
    symbol: "c",
    localization: {
      id: "copriferro",
      defaultMessage: "Copriferro",
    },
  },
};
export const VALIDATE = (value?: CustomInputRinforzoNodoValue) =>
  !!value &&
  Object.keys(FIELDS).every(
    (k) => !!(value as unknown as Record<string, any>)[k]
  ); // all fields are required
